export default __webpack_public_path__ + "static/media/C1_Logo_White_RGB.82308291.png";